<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    var url = window.location.href;
    var cookie = this.baseUrl.getCookie("userInfo");
    console.log("cookie"+cookie);
    if (cookie == "") {
      //通过链接点进来的
      // if (url.indexOf('/pageInfo?manuscriptId=')!=-1) {
      //   localStorage.setItem("pageinfo",url);
      //   this.$router.push(this.$route.fullPath);
      // }
      if(url.indexOf('/pageInfo?manuscriptId=')!=-1){
        localStorage.setItem("pageinfo",url);
        var url = this.$route.fullPath.replace('pageInfo','layoutnologin');
        this.$router.push(url);
      }else if (url.indexOf('/layoutnologin?manuscriptId=')!=-1) {
        this.$router.push(this.$route.fullPath);
      }
      else{
        this.baseUrl.setCookie("userInfo", "", -1);
        this.$router.push('/');
      }
    }else{
      if (this.$route.fullPath=="/") {
        this.$router.push("/homepage");
      }else{
        this.$router.push(this.$route.fullPath);
      }
    }
  },
}

</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue